import { render } from "./priceBlock.vue?vue&type=template&id=4897f615&ts=true"
import script from "./priceBlock.vue?vue&type=script&lang=ts"
export * from "./priceBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__